module.exports = __webpack_public_path__ + "static/media/glass8.a37727f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glass8.png
// module id = 733
// module chunks = 0